import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import classNames from "classnames";
import { Form } from "react-form";
import { connect } from "react-redux";
import isEqual from "lodash-es/isEqual";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableBody from "@material-ui/core/TableBody";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";

import { withStyles } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import MenuBook from "@material-ui/icons/MenuBook";
import ChevronRight from "@material-ui/icons/ChevronRight";
import CloudDownload from "@material-ui/icons/CloudDownload";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Warning from "@material-ui/icons/Warning";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import { FinalReport } from "../models";
import { AccomplishmentParcel } from "../../accomplishment/models";
import { InitialLandReporting } from "../../land_reporting/models";

import TextField from "../../common/TextField";
import EnhancedTableHead from "../../common/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../common/Paginator";
import CustomTableCell from "../../common/TableCell";
import FileInput from "../../common/FileInput";
import Select from "../../common/Select";
import HelpLabel from "../../common/HelpLabel";
import WarningDialog from "../../common/WarningDialog";
import Switch from "../../common/Switch";
import { createSelector } from "../../common/orm";
import { COUNTIES, TOWNSHIPS, RANGES, SECTIONS, ACTIVITIES, OPENS } from "../../../api/constants";

function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : null;
}

const getParcelsCompleted = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, id) => {
        return session.AccomplishmentParcel.filter({ final: id, status: "Completed" }).orderBy("id", "desc").toModelArray();
    }
);

const styles = theme => ({
    titleContainer: {
        backgroundColor: theme.palette.primary.main,
        textAlign: "center"
    },
    centerButtons: {
        justifyContent: "center",
        marginTop: 24
    },
    closeIcon: {
        float: "right",
        color: "#fff",
        marginTop: -16,
        marginRight: -16
    },
    supportIcon: {
        width: "3em",
        height: "3em",
        color: "#fff",
        marginLeft: 32
    },
    rightAlign: {
        textAlign: "right"
    },
    button: {
        marginRight: theme.spacing(2)
    },
    flex: {
        flex: 1
    },
    minWidth: {
        minWidth: 400
    },
    buttonFloat: {
        marginLeft: "auto",
        marginRight: "auto",
        display: "table"
    },
    table: {
        width: "auto",
        "& tbody tr:nth-child(even)": {
            backgroundColor: "#ffeff2"
        }
    },
    deleteWidth: {
        minWidth: 32,
        width: 32,
        height: 32,
        marginRight: 8,
    },
    centerAlign: {
        textAlign: "center"
    },
    nowrap: {
        whiteSpace: "nowrap"
    },
    floatLeft: {
        float: "left"
    },
    trds: {
        backgroundColor: "#FF9999"
    },
    widthTwoHundred: {
        width: 200
    },
    widthOneFifty: {
        width: 150
    },
    widthOneHundred: {
        width: 100
    },
    widthOneHundred2: {
        width: 100,
        marginTop: 10
    },
    widthThreeHundred: {
        width: 300
    },
    filter: {
        float: "right",
        marginTop: -4
    }
});

class ParcelTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadEdit: false,
            open: false,
            open2: false,
            cpFilter: getCookieValue(props.final_report.id.toString() + "finalcpFilter"),
        };
    }

    componentDidMount() {
        const { handleUnsavedFields } = this.props;
        document.title = "Final Report: Parcels - Lessard Sams Outdoor Heritage Council";
        this.props.onRef(this);
        const _this = this;
        // FIXME: react-forms calls formDidUpdate when (if) validation is ran right away
        // making it appear there is a edited field even if there isn't
        // Reset fields to false to not require validation when mounted
        setTimeout(function () {
            handleUnsavedFields(false);
            _this.props.appContainer.current.scrollTop();
        }, 1);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    updateAP(values, fromStepper) {
        const { ormFinalReportUpdate, history, handleUnsavedFields, handleNext, final_report } = this.props;
        const { id } = final_report;
        const { uploadEdit } = this.state;

        if (Number.isInteger(fromStepper)) {
            values.activeStep = fromStepper;
        }
        if (!uploadEdit && final_report.signup_criteria !== "") {
            values.signup_criteria = final_report.signup_criteria;
        }
        values.modify_date_label = final_report.modify_date_label;

        ormFinalReportUpdate({
            id: id,
            ...values
        });

        handleUnsavedFields(false);

        if (!Number.isInteger(fromStepper)) {
            if (this.state.draftClick) {
                history.push("/dashboard/");
            } else {
                handleNext();
            }
        }
    }

    fileChange = () => {
        this.setState({ uploadEdit: true });
    };

    returnDialog = () => {
        this.setState({ open: false });
    };

    filterByValue = (array, string) => {
        return array.filter(o =>
            Object.keys(o).some(k => o[k] && o[k].toString().toLowerCase().includes(string.toLowerCase())));
    };

    setFilter = (val) => {
        const { final_report } = this.props;
        this.setState({ cpFilter: val });
        document.cookie = final_report.id.toString() + "finalcpFilter=" + (val ? val : "");
    };

    render() {
        const {
            classes,
            final_report,
            handleUnsavedFields,
            ormAccomplishmentParcelDelete,
            ormAccomplishmentParcelUpdate,
            ormAccomplishmentParcelReload,
            ormInitialLandReportingDelete,
            authState,
            settings,
            ActionMenu
        } = this.props;
        var is_read_only = true;
        if ((authState && authState.user && authState.user.role === "admin") || final_report.status === "Draft")
            is_read_only = false;
        if (authState && authState.user && authState.user.role === "readonly")
            is_read_only = true;

        var is_admin = false;
        if (authState && authState.user && authState.user.role === "admin")
            is_admin = true;
        var { completed_parcels } = this.props;
        const { open, open2, cpFilter } = this.state;

        if (cpFilter) {
            completed_parcels = this.filterByValue(completed_parcels, cpFilter);
        }

        return (
            <>
                <Form
                    getApi={el => (this.form = el)}
                    key={final_report.id}
                    dontValidateOnMount={true}
                    validateOnSubmit={true}
                    defaultValues={final_report.formData}
                    formDidUpdate={() => handleUnsavedFields(true)}
                    onSubmit={(values, fromStepper) => this.updateAP(values, fromStepper)}>
                    {formApi => (
                        <form onSubmit={formApi.submitForm}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <HelpLabel
                                        inputLabel="Parcels"
                                        showLabel={true}
                                        title={true}
                                        helpText={settings.parcels_tab_help}
                                    />
                                    {ActionMenu}
                                </Grid>
                                <Grid item xs={12} md={10} lg={8} xl={7}>
                                    <div className="insborder">
                                        <Typography gutterBottom>
                                            Programs must provide a parcel lists showing specific parcels where work is anticipated to take place.
                                            If this is a program with a sign up program and parcels are to be determined during that process, please
                                            attach details on the program and the specific prioritization criteria used for that program.
                                        </Typography>
                                        <Typography>
                                            Uncertain which regions your parcel is in? – <a rel="noopener noreferrer" href="https://mnatlas.org/gis-tool/?id=k_0414" target="_blank">click here to zoom in on a map</a>. If you need to change the Eco Region, update the check boxes are under the General Tab.
                                        </Typography>
                                        <Typography>
                                            If your parcel list includes any acquisition parcels that contain buildings, 
                                            please supply information as necessary to ensure compliance with 
                                            the <a rel="noopener noreferrer" href="https://www.lsohc.mn.gov/manager_info/(R)Guidelines%20for%20Aquisition%20Parcels%20with%20Structures%20or%20Buildings.pdf" target="_blank">Guidelines for Acquisition Parcels with Structures/Buildings</a>.
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={10} lg={8} xl={7}>
                                    <FileInput
                                        field="signup_criteria"
                                        id="signup_criteria"
                                        label="Sign-up Criteria"
                                        disabled={is_read_only}
                                        eventHandle={this.fileChange}
                                    >
                                        <HelpLabel
                                            inputLabel="Sign-up Criteria"
                                            showLabel={true}
                                            helpText="The sign-up criteria is only required for projects that currently have no parcels."
                                        />
                                    </FileInput>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        eventHandle={this.setFilter}
                                        field="_filter"
                                        label="Filter"
                                        filterInput
                                        className={classes.filter}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ overflowX: "auto" }}>
                                        <ParcelTable
                                            ormAccomplishmentParcelUpdate={ormAccomplishmentParcelUpdate}
                                            ormAccomplishmentParcelDelete={ormAccomplishmentParcelDelete}
                                            ormInitialLandReportingDelete={ormInitialLandReportingDelete}
                                            rows={completed_parcels}
                                            final_report={final_report}
                                            is_read_only={is_read_only}
                                            classes={classes}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} className={classes.centerAlign}>
                                    <Button variant="contained" type="button" className={classes.button} onClick={() => window.open("/reports/accomplishmentplan/" + final_report.accomplishment_id + "/parcel_download/True")}>
                                        Download Excel Parcel List&nbsp;&nbsp;&nbsp;<CloudDownload />
                                    </Button>
                                </Grid>
                                {is_admin && (
                                    <Grid item xs={12} className={classes.centerAlign}>
                                        <Button variant="contained" type="button" color="primary" className={classes.button} onClick={() => window.open("/reports/accomplishmentplan/" + final_report.accomplishment_id + "/parcel_conveyance_download")}>
                                            Download Conveyed Parcel List&nbsp;&nbsp;&nbsp;<CloudDownload />
                                        </Button>
                                        <Button disabled={is_read_only} color="primary" variant="contained" type="button" onClick={() => this.setState({ open2: true })}>
                                            Upload Conveyed Parcel List&nbsp;&nbsp;&nbsp;<CloudUpload />
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item xs={12} className={classes.rightAlign}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={is_read_only}
                                        onClick={() => this.setState({ draftClick: true, submitClicked: true })}
                                        className={classes.button}>
                                        Save Draft and Return to Dashboard
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={is_read_only}
                                        color="primary"
                                        onClick={() => this.setState({ draftClick: false, submitClicked: true })}>
                                        Save and Proceed to Attachments <ChevronRight />
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Form>
                <ParcelUpload ormAccomplishmentParcelReload={ormAccomplishmentParcelReload} authState={authState} final_report={final_report} classes={classes} open={open} returnDialog={this.returnDialog} />
                <ParcelUpload2 authState={authState} final_report={final_report} classes={classes} open={open2} returnDialog={() => this.setState({ open2: false })} />
            </>
        );
    }
}

class ParcelTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            warningOpen: false,
            page: getCookieValue(props.final_report.id.toString() + "page") ? parseInt(getCookieValue(props.final_report.id.toString() + "page")) : 0,
            rowsPerPage: getCookieValue(props.final_report.id.toString() + "rowsPerPage") ? parseInt(getCookieValue(props.final_report.id.toString() + "rowsPerPage")) : 10,
            order: getCookieValue(props.final_report.id.toString() + "apOrder") ? getCookieValue(props.final_report.id.toString() + "apOrder") : "desc",
            orderBy: getCookieValue(props.final_report.id.toString() + "orderBy"),
            open: false,
            popupId: null,
            test: window.performance.now(),
            deleteOpen: false,
            delete_name: null,
            delete_id: null,
            land_reporting_id: null,
        };
    }


    columnData = [
        { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" },
        { id: "name", numeric: false, label: "Name", allowSort: true },
        { id: "county", numeric: false, label: "County", allowSort: true },
        { id: "township", numeric: false, label: "Township", allowSort: true },
        { id: "range", numeric: false, label: "Range", allowSort: true },
        { id: "direction", numeric: false, label: "Direction", allowSort: true },
        { id: "section", numeric: false, label: "Section", allowSort: true },
        { id: "acres", numeric: true, label: "# of Acres", allowSort: true },
        { id: "cost_estimate", numeric: true, label: "Budgeting Estimated Cost ($)", allowSort: true },
        { id: "description", numeric: false, label: "Description", allowSort: true },
        { id: "activity", numeric: false, label: "Activity", allowSort: true },
        { id: "existing_protection", numeric: false, label: "Existing Protection?", allowSort: true },
        { id: "open_hunting", numeric: false, label: "Open to hunting per State of Minnesota regulations?", allowSort: true },
        { id: "open_fishing", numeric: false, label: "Open to fishing per State of Minnesota regulations?", allowSort: true },
        { id: "buildings", numeric: true, label: "# of Buildings / Improvements", allowSort: true },
        { id: "buildings_description", numeric: false, label: "Buildings / Improvements Description", allowSort: true },
        { id: "estimated_building_value", numeric: true, label: "Value of Buildings / Improvements", allowSort: true },
        { id: "disposition", numeric: false, label: "Disposition of Improvements", allowSort: true },
    ];
    typingTimer = [];
    objectsToUpdate = [];

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.rows, this.props.rows) && this.props.rows.length > 0 && this.state.orderBy) {
            this.handleRequestSort(null, this.state.orderBy, true);
        }
    }

    updateRecord = (value, element, id) => {
        const { ormAccomplishmentParcelUpdate } = this.props;
        const comp = this;

        const val = {
            id: id,
            [element]: value
        }

        comp.objectsToUpdate[id] = { ...comp.objectsToUpdate[id], ...val };

        clearTimeout(this.typingTimer[id]);
        this.typingTimer[id] = setTimeout(function () {
            ormAccomplishmentParcelUpdate(comp.objectsToUpdate[id]);
        }, 1000);
    };

    handleChangePage = (event, page) => {
        const { final_report } = this.props;
        this.setState({ page });
        document.cookie = final_report.id.toString() + "page=" + page;
    };

    handleChangeRowsPerPage = event => {
        const { final_report } = this.props;
        this.setState({ rowsPerPage: event.target.value, page: 0 });
        document.cookie = final_report.id.toString() + "rowsPerPage=" + event.target.value;
        document.cookie = final_report.id.toString() + "page=0";
    };

    handleRequestSort = (event, property, refresh) => {
        const { final_report } = this.props;
        const orderBy = property;
        let order = "asc";

        if (this.state.orderBy === property && this.state.order === "asc") {
            order = "desc";
        }
        if (refresh === true)
            order = this.state.order;

        var columnData = this.columnData;
        if (!columnData)
            return;

        document.cookie = final_report.id.toString() + "order=" + order;
        document.cookie = final_report.id.toString() + "orderBy=" + orderBy;

        this.props.rows.sort(function (a, b) {
            var numeric = columnData.find(cD => cD.id === orderBy).numeric;
            if (numeric) {
                if (order === "desc") return parseFloat(b[orderBy]) < parseFloat(a[orderBy]) ? -1 : 1;
                else return parseFloat(a[orderBy]) < parseFloat(b[orderBy]) ? -1 : 1;
            } else {
                if (order === "desc")
                    return (b[orderBy] || "").toUpperCase() < (a[orderBy] || "").toUpperCase() ? -1 : 1;
                else return (a[orderBy] || "").toUpperCase() < (b[orderBy] || "").toUpperCase() ? -1 : 1;
            }
        });

        this.setState({ order, orderBy });
    };

    returnDialog2 = () => {
        this.setState({ open: false });
    };

    updateForm = () => {
        this.setState({ test: window.performance.now() })
    };

    render() {
        const { rows, ormAccomplishmentParcelDelete, classes, is_read_only, ormAccomplishmentParcelUpdate, ormInitialLandReportingDelete } = this.props;
        const { warningOpen, page, rowsPerPage, order, orderBy, open, popupId, test, deleteOpen, delete_name, delete_id, land_reporting_id } = this.state;

        return (
            <>
                <Table className={classes.table} key={test}>
                    <EnhancedTableHead
                        columnData={this.columnData}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={this.handleRequestSort} />
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                            return (
                                <TableRow hover key={n.id}>
                                    <CustomTableCell className={classes.nowrap}>
                                        <Tooltip title="Edit Initial Land Report">
                                            <Button
                                                color="primary"
                                                className={classes.deleteWidth}
                                                component={Link}
                                                to={"/land_reporting/" + n.land_reporting_id}>
                                                {/*onClick={() => window.open("/#/land_reporting/" + n.land_reporting_id)}>*/}
                                                <MenuBook color="primary" />
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Edit Parcel in Popup">
                                            <Button
                                                color="primary"
                                                disabled={is_read_only}
                                                className={classes.deleteWidth}
                                                onClick={() => this.setState({ popupId: n, open: true })}>
                                                <EditIcon color="primary" />
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Delete Parcel">
                                            <Button
                                                color="primary"
                                                disabled={is_read_only}
                                                className={classes.deleteWidth}
                                                onClick={() => this.setState({ deleteOpen: true, delete_name: n.name, delete_id: n.id, land_reporting_id: n.land_reporting_id })}>
                                                <DeleteIcon color="primary" />
                                            </Button>
                                        </Tooltip>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "name"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        className={classes.widthTwoHundred}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.name ? Math.ceil(n.name.length / 50) : 1}
                                                        tableFormat
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="name"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "county"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneFifty}
                                                        tableFormat
                                                        options={COUNTIES}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="county"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell className={!n.has_geom && classes.trds}>
                                        <Form key={n.id + "township"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneHundred}
                                                        tableFormat
                                                        options={TOWNSHIPS}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="township"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell className={!n.has_geom && classes.trds}>
                                        <Form key={n.id + "range"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneHundred}
                                                        tableFormat
                                                        options={RANGES}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="range"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell className={!n.has_geom && classes.trds}>
                                        <Form key={n.id + "direction"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        className={classes.widthOneHundred}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.direction ? Math.ceil(n.direction.length / 50) : 1}
                                                        tableFormat
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="direction"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell className={classNames(classes.nowrap, !n.has_geom && classes.trds)}>
                                        <Form key={n.id + "section"} defaultValues={n}>
                                            {formApi => (
                                                <form style={{ display: "inline" }} onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={n.has_geom ? classes.widthOneHundred : classes.widthOneHundred2}
                                                        tableFormat
                                                        options={SECTIONS}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="section"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                        {!n.has_geom && (
                                            <Tooltip title="Warning">
                                                <Button
                                                    color="primary"
                                                    className={classes.deleteWidth}
                                                    onClick={() => this.setState({ warningOpen: true })}>
                                                    <Warning color="primary" />
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "acres"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.acres ? Math.ceil(n.acres.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthOneHundred}
                                                        useNumber
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="acres"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "cost_estimate"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.cost_estimate ? Math.ceil(n.cost_estimate.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthOneHundred}
                                                        useTextFormat
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="cost_estimate"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "description"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.description ? Math.ceil(n.description.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthThreeHundred}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="description"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "activity"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthTwoHundred}
                                                        tableFormat
                                                        options={ACTIVITIES}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="activity"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "existing_protection"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneHundred}
                                                        tableFormat
                                                        options={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="existing_protection"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "open_hunting"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneFifty}
                                                        tableFormat
                                                        options={OPENS}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="open_hunting"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "open_fishing"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <Select
                                                        disabled={is_read_only}
                                                        className={classes.widthOneFifty}
                                                        tableFormat
                                                        options={OPENS}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="open_fishing"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "buildings"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.buildings ? Math.ceil(n.buildings.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthOneHundred}
                                                        useNumber
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="buildings"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "buildings_description"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        className={classes.widthThreeHundred}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.buildings_description ? Math.ceil(n.buildings_description.length / 50) : 1}
                                                        tableFormat
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="buildings_description"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "estimated_building_value"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.estimated_building_value ? Math.ceil(n.estimated_building_value.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthOneFifty}
                                                        useTextFormat
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="estimated_building_value"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Form key={n.id + "disposition"} defaultValues={n}>
                                            {formApi => (
                                                <form onSubmit={formApi.submitForm}>
                                                    <TextField
                                                        disabled={is_read_only}
                                                        multiline
                                                        rows={1}
                                                        maxRows={3}
                                                        // rows={n.disposition ? Math.ceil(n.disposition.length / 50) : 1}
                                                        tableFormat
                                                        className={classes.widthTwoHundred}
                                                        eventHandleProps1={n.id}
                                                        eventHandle={this.updateRecord}
                                                        field="disposition"
                                                        label="NOLABEL"
                                                        fullWidth
                                                    />
                                                </form>
                                            )}
                                        </Form>
                                    </CustomTableCell>
                                </TableRow>
                            );
                        })}
                        {rows.length < 1 && (
                            <TableRow>
                                <CustomTableCell colSpan={this.columnData.length} className={classes.centerAlign}>
                                    No Parcels Found
                                </CustomTableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {rows.length > 10 && (
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={this.columnData.length}
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    classes={{
                                        toolbar: classes.floatLeft
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActionsWrapped}
                                />
                            </TableRow>
                        </TableFooter>
                    )}
                </Table>
                <WarningDialog
                    confirmAction={() => {
                        if (land_reporting_id) {
                            ormInitialLandReportingDelete(land_reporting_id);
                        }
                        ormAccomplishmentParcelDelete(delete_id);
                        this.setState({ deleteOpen: false });
                    }}
                    cancelAction={() => this.setState({ deleteOpen: false })}
                    open={deleteOpen}
                    title="Delete Parcel"
                    confirmText="Delete Parcel"
                    text={"Are you sure you wish to delete " + delete_name + "? The associated initial land reporting form will also be deleted."}
                />

                <Dialog open={warningOpen} classes={{ paper: classes.minWidth }}>
                    <DialogTitle className={classes.titleContainer}>
                        <Warning className={classes.supportIcon} />
                        <IconButton onClick={() => this.setState({ warningOpen: false })} className={classes.closeIcon}>
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ marginTop: 24 }}>
                            Parcel has an invalid TRDS and will need to be corrected before it can be displayed on the parcel map.
                        </DialogContentText>
                        <DialogActions className={classes.centerButtons}>
                            <Button onClick={() => this.setState({ warningOpen: false })} color="primary" variant="contained">
                                Ok
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
                <EditParcel updateForm={this.updateForm} ormAccomplishmentParcelUpdate={ormAccomplishmentParcelUpdate} classes={classes} parcel={popupId} open={open} returnDialog={this.returnDialog2} />
            </>
        );
    }
}

class ParcelUpload extends Component {
    state = {
        loading: false,
        results: null
    };

    uploadDocument = values => {
        var { authState, history, authLogout, final_report, ormAccomplishmentParcelReload } = this.props;
        this.setState({ loading: true, results: null });
        fetch("/reports/accomplishmentplan/" + final_report.accomplishment_id + "/parcel_upload", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + authState.user.auth_token
            },
            body: JSON.stringify(values)
        }).then(e => {
            if (e.status === 401) {
                history.push("/");
                authLogout();
            } else if (e.status === 500) {
                this.setState({ loading: false, results: "There has been an error uploading parcels. Please check your document for any errant data and contact LSOHC staff if the problem still persists." });
            } else {
                e.json().then(data => {
                    var msg = "<b>Upload Results:</b><br/>";
                    data.message.forEach(function (m) {
                        msg += m.name + ": " + m.message + "<br/>";
                    })
                    this.setState({ loading: false, results: msg });
                    ormAccomplishmentParcelReload();
                });
            }
        });
    };

    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            file: isRequired(values.file)
        };

        return valObj;
    };

    render() {
        const { classes, open, returnDialog } = this.props;
        const { loading, results } = this.state;

        return (
            <Dialog open={open} classes={{ paper: classes.minWidth }}>
                <Toolbar>
                    <Typography variant="h3" className={classes.flex}>
                        Upload Parcels
                    </Typography>
                    <IconButton aria-label="Close Dialog" onClick={() => { this.setState({ results: null }); returnDialog(); }}>
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    <DialogContentText>
                        <Form
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            validateError={this.errorValidator}
                            onSubmit={values => this.uploadDocument(values)}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FileInput field="file" id="file_upl" label="Parcel Spreadsheet" fullWidth>
                                                <HelpLabel
                                                    inputLabel="Parcel Spreadsheet"
                                                    showLabel={true}
                                                    helpText="Upload an Excel spreadsheet (.xlsx) containing your parcels on each row. The column names should match the spreadsheet generated from the 'Download Excel Parcel Template' or 'Download Excel Parcel List' buttons."
                                                />
                                            </FileInput>
                                            <Switch
                                                field="delete_current"
                                                name="delete_current">
                                                <HelpLabel
                                                    inputLabel="Remove All Existing Parcels? (Read Help Bubble Before Proceeding)"
                                                    showLabel={true}
                                                    helpText={
                                                        <div>Select Yes to overwrite any existing parcels in your list prior to uploading these new parcels.
                                                            Warning: Deletion of parcels is permanent. <b><u>Any progress within your initial land reporting forms will be lost.</u></b>
                                                        </div>
                                                    }
                                                />
                                            </Switch>
                                            <div dangerouslySetInnerHTML={{ __html: results }} />
                                            {loading && (
                                                <CircularProgress size={24} className={classes.buttonFloat} />
                                            )}
                                            {!loading && (
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.buttonFloat}>
                                                    Upload
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

class ParcelUpload2 extends Component {
    state = {
        loading: false,
        results: null
    };

    uploadDocument = values => {
        var { authState, history, authLogout, final_report } = this.props;
        this.setState({ loading: true, results: null });
        fetch("/reports/accomplishmentplan/" + final_report.accomplishment_id + "/parcel_conveyance_upload", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + authState.user.auth_token
            },
            body: JSON.stringify(values)
        }).then(e => {
            if (e.status === 401) {
                history.push("/");
                authLogout();
            } else {
                e.json().then(data => {
                    var msg = "<b>Upload Results:</b><br/>";
                    data.message.forEach(function (m) {
                        msg += m.name + ": " + m.message + "<br/>";
                    })
                    this.setState({ loading: false, results: msg });
                });
            }
        });
    };

    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            file: isRequired(values.file)
        };

        return valObj;
    };

    render() {
        const { classes, open, returnDialog } = this.props;
        const { loading, results } = this.state;

        return (
            <Dialog open={open} classes={{ paper: classes.minWidth }}>
                <Toolbar>
                    <Typography variant="h3" className={classes.flex}>
                        Upload Conveyed Parcels
                    </Typography>
                    <IconButton aria-label="Close Dialog" onClick={() => { this.setState({ results: null }); returnDialog(); }}>
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    <DialogContentText>
                        <Form
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            validateError={this.errorValidator}
                            onSubmit={values => this.uploadDocument(values)}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FileInput field="file" id="file_upl" label="Parcel Spreadsheet" fullWidth>
                                                <HelpLabel
                                                    inputLabel="Parcel Spreadsheet"
                                                    showLabel={true}
                                                    helpText="Upload an Excel spreadsheet (.xlsx) containing your parcels on each row. The column names should match the spreadsheet generated from the 'Download Excel Parcel Template' or 'Download Excel Parcel List' buttons."
                                                />
                                            </FileInput>
                                            <div dangerouslySetInnerHTML={{ __html: results }} />
                                            {loading && (
                                                <CircularProgress size={24} className={classes.buttonFloat} />
                                            )}
                                            {!loading && (
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.buttonFloat}>
                                                    Upload
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

class EditParcel extends Component {
    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name)
        };

        return valObj;
    };

    editParcel = values => {
        var { ormAccomplishmentParcelUpdate, returnDialog, parcel, updateForm } = this.props;

        ormAccomplishmentParcelUpdate({
            id: parcel.id,
            ...values
        });

        updateForm();
        returnDialog();
    };

    render() {
        const { classes, open, returnDialog, parcel } = this.props;

        return (
            <Dialog open={open} classes={{ paper: classes.minWidth }}>
                <Toolbar>
                    <Typography variant="h3" className={classes.flex}>
                        Edit Parcel
                    </Typography>
                    <IconButton aria-label="Close Dialog" onClick={returnDialog}>
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    <DialogContentText>
                        <Form
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            validateError={this.errorValidator}
                            defaultValues={parcel}
                            onSubmit={values => this.editParcel(values)}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <TextField field="name" label="Name" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Select options={COUNTIES} field="county" label="County" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Select options={TOWNSHIPS} field="township" label="Township" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Select options={RANGES} field="range" label="Range" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField field="direction" label="Direction" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Select options={SECTIONS} field="section" label="Section" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField field="acres" useNumber label="# of Acres" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField field="cost_estimate" useTextFormat label="Budgeting Estimated Cost" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField field="description" label="Description" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Select options={ACTIVITIES} field="activity" label="Activity" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Select options={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]} field="existing_protection" label="Existing Protection?" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Select options={OPENS} field="open_hunting" label="Open to hunting per State of Minnesota regulations?" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Select options={OPENS} field="open_fishing" label="Open fishing per State of Minnesota regulations?" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField useNumber field="buildings" label="# of Buildings/Improvements" fullWidth />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField useTextFormat field="estimated_building_value" label="Value of Buildings/Improvements" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField field="buildings_description" label="Buildings/Improvements Description" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField field="disposition" label="Disposition of Improvements" fullWidth />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                onClick={formApi.submitForm}
                                                variant="contained"
                                                color="primary"
                                                className={classes.buttonFloat}>
                                                Save
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

ParcelTab = connect(
    (state, ownProps) => ({
        completed_parcels: getParcelsCompleted(state, ownProps),
        authState: state.auth
    }),
    {
        ...FinalReport.actions,
        ...AccomplishmentParcel.actions,
        ...InitialLandReporting.actions
    }
)(ParcelTab);

export default withStyles(styles)(withRouter(ParcelTab));
